export default "__VITE_ASSET__CGbKkFTm__"